module.exports = __webpack_public_path__ + "img/logo.9fce9fa6.png";